import { render } from "./AccountSettingGeneralIndex.vue?vue&type=template&id=4fed0bcc"
import script from "./AccountSettingGeneralIndex.vue?vue&type=script&lang=js"
export * from "./AccountSettingGeneralIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__